import { userLogout } from '@app/src/views/Login/login/state/login/actions';
import { CONSTANTS } from '../../../filter/state/validationReportToken/constants';
import * as actionTypes from './actionTypes';
import { serviceDetail, serviceRefreshToken } from './services';

const fetchDetailRequest = () => ({
  type: actionTypes.FETCH_DETAIL_REQUEST
});

const fetchDetailFailure = (errorMessage: string) => ({
  type: actionTypes.FETCH_DETAIL_FAILURE,
  errorMessage
});

const fetchDetailSuccess = (data) => ({
  type: actionTypes.FETCH_DETAIL_SUCCESS,
  data
});

const fetchGetRefreshToken = () => ({
  type: actionTypes.FETCH_REFRESHTOKEN_REQUEST
});

export const selectedItemDetail = (index: number) => ({
  type: actionTypes.SELECTED_ITEM_DETAIL,
  index
});

export const fetchDetail = (values: object, url: string, reRunRefresh: boolean = true): Function => {
  return async (dispatch, getState) => {
    dispatch(fetchDetailRequest());
    try {
      const state = getState();
      const isRangeError = state.validationDateRange.error;
      if(isRangeError) throw new Error();
      const data = await serviceDetail.getData(values, url);
      dispatch(fetchDetailSuccess(data));
    } catch(e) {
      if (e.code === CONSTANTS.expiredAccessToken && reRunRefresh) {
        await dispatch(fetchRefreshToken(values, url));
        return;
      }
      dispatch(fetchDetailFailure(e.message));
    }
  }
};

const fetchRefreshToken = (values, url) => {
  return async dispatch => {
    dispatch(fetchGetRefreshToken());
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await serviceRefreshToken.getData(refreshToken);
      await dispatch(fetchDetail(values, url, false));
    } catch (error) {
      await dispatch(userLogout())
    }
  }
}